// extracted by mini-css-extract-plugin
export default {"dropdown":"InboxDropdown_dropdown__pqYcu","header":"InboxDropdown_header__FhVXm","heading":"InboxDropdown_heading__+qOQb"};